import { render, staticRenderFns } from "./DailySalesShipmentRatioTable.vue?vue&type=template&id=6a03bfca&scoped=true"
import script from "./DailySalesShipmentRatioTable.vue?vue&type=script&lang=js"
export * from "./DailySalesShipmentRatioTable.vue?vue&type=script&lang=js"
import style0 from "./DailySalesShipmentRatioTable.vue?vue&type=style&index=0&id=6a03bfca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a03bfca",
  null
  
)

export default component.exports